import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { _breakP } from '../../js/lib/utils.js';

gsap.registerPlugin(ScrollTrigger);

export default class footerEntry {
  constructor() {
    this.section = document.querySelector('.js-footerEntry');
    this.bg = this.section?.querySelector('.js-footerEntryBg');
    this.light = this.section?.querySelector('.js-footerEntryLight');
    this.bgImg = this.bg?.querySelector('.photo__image');
    this.lightImg = this.light?.querySelector('.photo__image');

    if (!this.section || !this.bgImg) return;

    // 1フレーム遅らせてレイアウト・Lenis 更新後に ScrollTrigger を計測
    requestAnimationFrame(() => this.init());
  }

  init() {
    if (this.timeline) return;

    // --- タイミング調整値（後から触る箇所はここだけ）---
    this.scrubConfig = {
      start: _breakP.SP ? '0% 90%' : '0% 80%',
      end: _breakP.SP ? '50% 20%' : '50% 30%'
    };
    this.lightFadeConfig = {
      // ScrollTrigger の start。'<section の何%> <viewport の何%>' 形式。
      // 例) 'top 50%' … section 上端がビューポート中央に入った瞬間（遅め）
      //     'top 80%' … section 上端がビューポート下から 20% 位置（早め）
      // trigger を this.light に変えると light 要素自身の位置基準になる
      start: _breakP.SP ? 'top 30%' : 'top 10%',
      duration: 4,
      ease: 'power2.out'
    };

    this.scrollTriggers = [];

    this.setupScrubTimeline();
    this.setupLightFadeIn();
    this.setupRefreshOnLoad();
  }

  setupScrubTimeline() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.section,
        start: this.scrubConfig.start,
        end: this.scrubConfig.end,
        scrub: 1,
        invalidateOnRefresh: true
        // markers: true,
      }
    });

    // bg: 彩度 + スケールをスクロールに同期
    this.timeline.fromTo(
      this.bgImg,
      { filter: 'saturate(2)', scale: 1.2 },
      { filter: 'saturate(1)', scale: 1, ease: 'power1.inOut' }
    );

    // light: bg と同タイミングでスケールのみ同期
    if (this.lightImg) {
      this.timeline.fromTo(
        this.lightImg,
        { scale: 1.2 },
        { scale: 1, ease: 'power1.inOut' },
        '<'
      );
    }

    this.scrollTriggers.push(this.timeline.scrollTrigger);
  }

  setupLightFadeIn() {
    if (!this.light) return;

    const st = ScrollTrigger.create({
      trigger: this.section,
      start: this.lightFadeConfig.start,
      once: true,
      onEnter: () => {
        gsap.to(this.light, {
          '--light-reveal': '100%',
          duration: this.lightFadeConfig.duration,
          ease: this.lightFadeConfig.ease
        });
      }
    });

    this.scrollTriggers.push(st);
  }

  setupRefreshOnLoad() {
    [this.bgImg, this.lightImg].forEach(img => {
      if (!img || img.complete) return;
      img.addEventListener('load', () => ScrollTrigger.refresh(), {
        once: true
      });
    });
  }

  destroy() {
    this.scrollTriggers?.forEach(st => st?.kill());
    this.timeline?.kill();
    this.timeline = null;
  }
}
